// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8304e48","455":"c5b92120","977":"07052118"}[chunkId] + ".chunk.js";
};